import {useState} from "react"
import "../css/header.css"
import {Badge, Drawer, IconButton, useMediaQuery, Tooltip, useTheme} from "@mui/material"
import {useBasket} from "../providers/basket-context"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCartOutlined"
import BasketContainer from "./basket-container"
import {useTranslation} from "react-i18next";

const Basket = () => {
    const [isBasketOpen, setIsBasketOpen] = useState(false)
    const {totalItems = 0, refreshBasketData} = useBasket()
    const isHasCart = totalItems > 0
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { t } = useTranslation()

    const handleBasketClick = () => {
        setIsBasketOpen(true)
    }

    const handleCloseBasket = () => {
        setIsBasketOpen(false)
        if (refreshBasketData) {
            refreshBasketData()
        }
    }

    return (
        <>
            <Tooltip title={`${t("MyCart")} · ${t("BasketLineCount", {count: totalItems})}`}>
            <IconButton color="inherit" onClick={handleBasketClick} style={{cursor: "pointer"}}
                        aria-label={`${t("MyCart")} · ${t("BasketLineCount", {count: totalItems})}`}>
                <Badge
                    color="error"
                    badgeContent={isHasCart ? totalItems : 0}
                    invisible={!isHasCart}
                    sx={{
                        "& .MuiBadge-badge": {
                            fontSize: "10px",
                            height: "15px",
                            minWidth: "15px",
                            borderRadius: "50%",
                            padding: "0 6px",
                            backgroundColor: "#de2626",
                            color: "#fff",
                        },
                    }}
                >
                    <ShoppingCartIcon/>
                </Badge>
            </IconButton>
            </Tooltip>

            {isMobile ? (
                <Drawer
                    anchor="bottom"
                    sx={{zIndex: theme => theme.zIndex.modal}}
                    open={isBasketOpen}
                    onClose={handleCloseBasket}
                    PaperProps={{
                        role: "dialog",
                        "aria-label": t("Basket"),
                        "aria-modal": true,
                        sx: {
                            height: "90%",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                        },
                    }}
                >
                    <BasketContainer onClose={handleCloseBasket}/>
                </Drawer>
            ) : (
                <Drawer
                    anchor="right"
                    sx={{zIndex: theme => theme.zIndex.modal}}
                    open={isBasketOpen}
                    onClose={handleCloseBasket}
                    variant="temporary"
                    PaperProps={{
                        role: "dialog",
                        "aria-label": t("Basket"),
                        "aria-modal": true,
                        sx: {
                            width: "576px",
                            maxWidth: "100vw",
                            height: "100%",
                            boxShadow: "0px 8px 10px -5px rgba(0,0,0,0.2)",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        },
                    }}
                >
                    <BasketContainer onClose={handleCloseBasket}/>
                </Drawer>
            )}
        </>
    )
}

export default Basket
